const TENNIS_SCORE_NAMES = [
   '0',
   '15',
   '30',
   '40',
   'AD',
];

const TENNIS_SCORE_SPEECH = [
   'Love',
   '15',
   '30',
   '40',
   'Advantage',
   'Deuce',
];

export { TENNIS_SCORE_NAMES, TENNIS_SCORE_SPEECH };